<template>
  <div style="display: block; height: 100%;">
    <div style="display: flex; flex-direction: row">
      <div class="tabbar-before">
        <slot name="tabbar-before" />
      </div>
      <f7-swiper ref="tabbarSwiper" :params="tabbarSwiperParams" class="tabbar-swiper">
        <f7-swiper-slide v-for="(object, index) in objects" :key="`swiper-tabbar-${index}`" @click.native="onTabbarClick(index)">
          <span class="swiper-slide-element" :style="{ color: currentIndex === index ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)' }">
            <slot name="tabbar-objects" :object="object" />
          </span>
          <span v-if="currentIndex == index" :style="{ transform: `translate(0%, -3px)`}" class="tabbar-indicator" />
        </f7-swiper-slide>
      </f7-swiper>
      <div class="tabbar-after">
        <slot name="tabbar-after" />
      </div>
    </div>
    <f7-swiper ref="tabSwiper" :params="tabSwiperParams" style="position: absolute; top: 48px; bottom: 0px; left: 0px; width: 100%;">
      <f7-swiper-slide v-for="(object, index) in objects" :key="`swiper-tabs-${index}`" class="tab-swiper-slide">
        <slot name="tab-objects" :object="object" :index="index" />
      </f7-swiper-slide>
    </f7-swiper>
  </div>
</template>

<script>
export default {
  data () {
    const that = this
    return {
      init: false,
      currentIndex: 0,
      tabbarSwiperParams: {
        slidesPerView: 'auto'
      },
      tabSwiperParams: {
        on: {
          slideChange () {
            that.currentIndex = this.activeIndex
            that.tabbarSwiper.slideTo(that.currentIndex)
            that.$emit('indexChange', that.currentIndex)
          }
        }
      }
    }
  },
  computed: {
    tabbarSwiper () { return this.$refs.tabbarSwiper.swiper },
    tabSwiper () { return this.$refs.tabSwiper.swiper }
  },
  methods: {
    onTabbarClick (index) {
      const previousIndex = this.currentIndex
      this.currentIndex = index
      this.tabbarSwiper.slideTo(index)
      this.tabSwiper.slideTo(index)
      this.$emit('tabbarClicked', { currentIndex: index, previousIndex })
    }
  },
  props: {
    objects: Array,
    initPage: {
      type: Number,
      default: 0
    }
  },
  watch: {
    initPage (v) {
      this.tabbarSwiper.slideTo(v, 0)
      this.tabSwiper.slideTo(v, 0)
    }
  },
  mounted () {
    this.tabbarSwiper.slideTo(this.initPage, 0)
    this.tabSwiper.slideTo(this.initPage, 0)
  }
}
</script>

<style lang="scss" scoped>
.tabbar-before, .tabbar-after {
  background-color: #4CAF50;
  height: 48px;
  line-height: 48px;
}
.tabbar-swiper {
  height: 48px;
  background-color: #4CAF50;
  flex: 1 1;
}
.swiper-slide-element {
  line-height: 48px;
  margin: 0px 16px;
}
.tabbar-indicator {
  position: absolute;
  top: 48px;
  left: 0px;
  height: 3px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 2;
}
.swiper-slide {
  width: auto;
}
.tab-swiper-slide.swiper-slide {
  width: 100%;
}
</style>
